export default __webpack_public_path__ + "static/media/coffeChair.0e7a7040.png";